export default function ListElementPlaceholder({
  styles,
  text = "Træk dokumenter hertil",
}) {
  return (
    <div
      className={`w-full bg-white text-textLightGray text-standard py-[11px] pl-[10px] border-[1px] border-dashed border-textLightGray ${styles}`}
    >
      {text}
    </div>
  );
}
